// extracted by css-extract-rspack-plugin
export default {"Product":"Product-module__Product__PUVnW","BackgroundGrid":"Product-module__BackgroundGrid__yl_29","Content":"Product-module__Content__xwaXS"};